import React from 'react';
import '../styles/Timeline.css';
import { format } from 'date-fns';
import { formatterLong } from '../styles/GlobalStyles';

function Timeline(props) {
    const data = props.data;
    // const forSale = props.forSale;
    return (
        <div className="timeline-container">
            <div className="timeline-text-container">
                <h3 className="body-bold colour-primary">
                    Timeline
                </h3>
            </div>
            <div className="timeline-body-container">
                {
                    data.map((item, index) =>
                        item.price !== null &&
                        <React.Fragment 
                            key={index}
                        >
                            <div className="timeline-element relative-container">
                                <div className="timeline-dot">
                                </div>
                                {
                                    item.date !== null ?
                                    <span className="label-regular-caps colour-secondary">
                                        {format(new Date(item.date), "MMM dd, yyyy")}
                                    </span>
                                    :
                                    <span className="label-regular-caps colour-secondary">
                                        Today
                                    </span>
                                }
                                <span className="body-semibold colour-primary">
                                    {
                                        item.event === "sold" || item.event === "Sold" ?
                                        `Sold${item.ownerNames === undefined || item.ownerNames === null || item.ownerIndividual !== false ? "" : ` to ${item.ownerNames}`}`
                                        :
                                        item.event === "listed_for_sale" || item.event === "Listed" ?
                                        `Listed${item.ownerNames === undefined || item.ownerNames === null || item.ownerIndividual !== false ? "" : ` by ${item.ownerNames}`}`
                                        :
                                        item.event === "resold" ?
                                        `Re-sold`
                                        :
                                        `${item.event.charAt(0).toUpperCase() + item.event.slice(1).toLowerCase()}`
                                    }
                                </span>
                                <span className="body-regular colour-primary">
                                    {formatterLong.format(item.price).replace(".00", "")}
                                </span>
                            </div>
                            {
                                item.period !== null &&
                                <div className="timeline-element">
                                    <span className={"body-regular text-italic " + (item.period.includes("below") ? "colour-error" : item.period.includes("above") ? "colour-green" : "colour-primary")}>
                                        {item.period}
                                    </span>
                                </div>
                            }
                        </React.Fragment>
                    )
                }
                <div 
                    className="timeline-element relative-container"
                >
                    <div className="timeline-dot">
                    </div>
                    <span className="label-regular-caps colour-secondary">
                        Present
                    </span>
                </div>
            </div>
        </div>
    )
};

export default Timeline;